export const dbTabs1 = {
  presentation: {
    descriptionTitle: "Beschreibung des Inserats",
    descriptionSub: "Legen Sie fest, ob die Beschreibung auf der Direktbuchungsseite jeder Einheit erscheint.",
    visible: "Sichtbar",
    hidden: "Ausgeblendet",
    amenitiesTitle: "Inklusivleistungen",
    amenitiesSub: "Legen Sie fest, welche Leistungen und Ausstattungen für jede Einheit in Ihrer Buchungsmaschine angezeigt werden.",
    amenitiesCount: "{count} Leistung | {count} Leistungen",
    editAmenitiesTitle: "Leistungen bearbeiten",
    edit: "Bearbeiten",
    imagesTitle: "Bilder der Unterkunft",
    imagesSubtitle: "Laden Sie Bilder hoch, sortieren Sie sie und legen Sie das Hauptbild jeder Einheit fest, das in Ihrer Buchungsmaschine erscheint.",
  },
  reservations: {
    updating: "Wird aktualisiert…",
    engineActive: "Buchungsmaschine aktiv",
    engineInactive: "Buchungsmaschine inaktiv",
    engineActiveDesc: "Gäste können Zimmer direkt über Ihren Link buchen.",
    engineInactiveDesc: "Direktbuchungen sind für dieses Hotel deaktiviert.",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    roomsAvailable: "Verfügbare Zimmer",
    colRoom: "Zimmer",
    colCap: "Kap.",
    colActive: "Aktiv",
    noRooms: "Keine Zimmer eingerichtet.",
    hotelLabel: "Hotel",
    unitActive: "Aktiv",
    unitInactive: "Inaktiv",
    enableNotice: "Aktivieren Sie Direktbuchungen, um Zimmer zu verwalten.",
    toastUpdated: "Aktualisiert.",
    toastUpdateError: "Aktualisierung nicht möglich.",
    toastGlobalUpdated: "Globaler Status aktualisiert.",
  },
  promotions: {
    title: "Angebote bei Direktbuchung",
    subtitle: "Legen Sie fest, welche aktiv sind, ob sie kombinierbar sind und in welcher Reihenfolge sie stehen.",
    loading: "Angebote werden geladen…",
    empty: "Für diese Unterkunft sind keine Angebote eingerichtet.",
    dragTitle: "Zum Umsortieren ziehen",
    switchTitle: "Bei Direktbuchung aktiv",
    badgeLabel: "Badge",
    badgePlaceholder: "z. B. -10 % / Deal",
    stackableLabel: "Kombinierbar",
    tip: "Tipp: Aktivieren Sie das Angebot, damit es bei Direktbuchung gilt, und nutzen Sie „Kombinierbar“, wenn es sich mit anderen Angeboten verbinden lässt.",
    toastLoadError: "Die Angebote konnten nicht geladen werden.",
    toastSaved: "Angebote erfolgreich gespeichert.",
    toastSaveError: "Die Angebote konnten nicht gespeichert werden.",
    dateFrom: "Ab {date}",
    dateUntil: "Bis {date}",
  },
  addons: {
    title: "Belegung und Aufschläge",
    hint1: "Nur eine Anpassung pro {scope}: Nachlass bei weniger Gästen",
    hintOr: "oder",
    hint2: "Aufschlag pro zusätzlichem Gast. Nicht beides.",
    perRoom: "Zimmer",
    perAccommodation: "Unterkunft",
    loading: "Konfiguration wird geladen…",
    emptyHotel: "Für dieses Hotel sind keine Zimmer eingerichtet.",
    thisAccommodation: "Diese Unterkunft",
    modeReduction: "Nachlass",
    modeSurcharge: "Aufschlag",
    modeNone: "Keine Anpassung",
    toastLoadError: "Die Belegungskonfiguration konnte nicht geladen werden.",
    toastSaved: "Belegung erfolgreich gespeichert.",
    toastSaveError: "Die Belegung konnte nicht gespeichert werden.",
  },
};
